import { render, staticRenderFns } from "./comment-placeholder.vue?vue&type=template&id=5986b2b3&lang=pug"
import script from "./comment-placeholder.vue?vue&type=script&lang=js"
export * from "./comment-placeholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports